import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MdWorkOutline } from "react-icons/md";
import { TfiLocationPin } from "react-icons/tfi";
import { CiMoneyBill } from "react-icons/ci";
import { RxTimer } from "react-icons/rx";
import { Helmet } from "react-helmet";

const RowContainerSearchCareers = ({ flag, data, scrollValue }) => {
  const rowContainer = useRef();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Adjust the number of items per page

  useEffect(() => {
    if (rowContainer.current) {
      rowContainer.current.scrollLeft += scrollValue;
    }
  }, [scrollValue]);

  const calculateDaysSincePosted = (postedDate) => {
    if (!postedDate) return "No posted date";
    const today = new Date();
    const postedDateObj = new Date(postedDate);
    if (isNaN(postedDateObj.getTime())) return "Invalid date";
    const timeDiff = today - postedDateObj;
    const daysSince = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    return daysSince >= 0 ? daysSince : "Future date";
  };

  const handleNext = () => {
    if (currentPage < Math.ceil(data.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const filterData = data.filter(item => item.companyName === "Nexify Infosystems");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filterData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(filterData.length / itemsPerPage);

  // Pagination buttons logic to display chunks
  const pageNumbers = [];
  const maxVisiblePages = 5; // Maximum pages to show (1-5, 6-10, etc.)

  // Calculate the start and end page numbers to display
  const startPage = Math.floor((currentPage - 1) / maxVisiblePages) * maxVisiblePages + 1;
  const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages);

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <Helmet>
        <title>Careers at Nexify Infosystems</title>
        <meta name="description" content="Explore exciting job opportunities at Nexify Infosystems. Browse through our current job openings and apply today." />
        <meta name="keywords" content="Nexify Infosystems, job opportunities, careers, job openings, apply now" />
      </Helmet>
        <div ref={rowContainer} className="w-full mt-6 my-16 py-5">
       {currentData && currentData.length > 0 ? (
         <>
           <div className="space-y-4"> {/* Adds spacing between each job item */}
             {currentData.map((item) => (
               <div key={item.id} className="bg-white p-6  border-b border-gray-300">
                 <h2 className="text-[24px] font-[400] text-[#0176b2]">
                   <Link
                     to={`/product/${item.id}`}
                     state={{ product: item }}
                     className="hover:underline"
                   >
                     {item.jobTitle}
                   </Link>
                 </h2>
                 <p className="text-[#222] text-[14px]"><strong className="text-[#515151] text-[14px]">Posted By:</strong> {calculateDaysSincePosted(item.postedDate)} days ago</p>
                 
                 <p className="text-[#222] text-[14px]"><strong className="text-[#515151] text-[14px]">Company Name:</strong> {item.companyName}</p>
                 <div className="flex items-center text-[14px] text-[#222]">
                 <strong className="text-[#515151] text-[14px]">Schedule:</strong>
                   <TfiLocationPin className="mr-1 text-sm" />
                   {item.jobType}
                 </div>
     
                 <div className="flex items-center text-[14px] text-[#222]">
                 <strong className="text-[#515151] text-[14px]">Job Experience:</strong>
                   <MdWorkOutline className="mr-1 text-sm" />
                   {item.experienceRequired}
                 </div>
                 <div className="flex items-center text-sm text-gray-600 mt-3">
                   <TfiLocationPin className="mr-1 text-sm" />
                   {item.location}
                 </div>
                 <p className="text-[#222] mt-2 line-clamp-4 text-[14px] text-justify leading-[1.8]" dangerouslySetInnerHTML={{ __html: item.jobDescription }} />
     
                 {/* <Link
                   to={`/product/${item.id}`}
                   state={{ product: item }}
                   className="text-[#143749] font-semibold text-sm hover:underline mt-3 block"
                 >
                   View Job &gt;&gt;
                 </Link> */}
               </div>
             ))}
           </div>
     
           {/* <div className="flex justify-center items-center mt-6 space-x-4">
             <button
               onClick={handlePrev}
               disabled={currentPage === 1}
               className={`px-6 py-2 bg-indigo-500 text-white rounded-full transition-all duration-300 ${
                 currentPage === 1 ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "hover:bg-indigo-600"
               }`}
             >
               Prev
             </button>
     
             {pageNumbers.map((number) => (
               <button
                 key={number}
                 onClick={() => paginate(number)}
                 className={`px-4 py-2 rounded-full text-lg transition-all duration-300 ${
                   currentPage === number ? "bg-indigo-500 text-white" : "bg-gray-200 text-gray-700 hover:bg-indigo-400"
                 }`}
               >
                 {number}
               </button>
             ))}
     
             <button
               onClick={handleNext}
               disabled={currentPage === totalPages}
               className={`px-6 py-2 bg-indigo-500 text-white rounded-full transition-all duration-300 ${
                 currentPage === totalPages ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "hover:bg-indigo-600"
               }`}
             >
               Next
             </button>
           </div> */}
         </>
       ) : (
         <p className="text-gray-600 text-[20px] text-center">No Job Found</p>
       )}
     </div>
     
    </>
  );
};

export default RowContainerSearchCareers;
